module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 128.ae061e52.png";